import ConsultasShared from "../profesor/ConsultasColegio";
export default function ConsultasColegio() {
    return <ConsultasShared />;
}
